import React, { useEffect } from 'react';

const SeoMeta = ({ title, description, keywords, ogTitle, ogDescription }) => {
  useEffect(() => {
    document.title = title;

    const setOrUpdateMeta = (selector, attr, value) => {
      let element = document.querySelector(selector);
      if (element) {
        element.setAttribute('content', value);
      } else {
        element = document.createElement('meta');
        if (selector.includes("name")) {
          element.setAttribute("name", attr);
        } else if (selector.includes("property")) {
          element.setAttribute("property", attr);
        }
        element.setAttribute("content", value);
        document.head.appendChild(element);
      }
    };

    // Clean up any old meta tags to prevent duplicates
    const tagsToRemove = ['description', 'keywords'];
    tagsToRemove.forEach(name => {
      const oldTags = document.querySelectorAll(`meta[name="${name}"]`);
      oldTags.forEach((tag, i) => {
        if (i > 0) tag.remove(); // keep only first one
      });
    });

    const ogTagsToRemove = ['og:title', 'og:description'];
    ogTagsToRemove.forEach(prop => {
      const oldTags = document.querySelectorAll(`meta[property="${prop}"]`);
      oldTags.forEach((tag, i) => {
        if (i > 0) tag.remove();
      });
    });

    setOrUpdateMeta("meta[name='description']", "description", description);
    setOrUpdateMeta("meta[name='keywords']", "keywords", keywords);
    setOrUpdateMeta("meta[property='og:title']", "og:title", ogTitle || title);
    setOrUpdateMeta("meta[property='og:description']", "og:description", ogDescription || description);
  }, [title, description, keywords, ogTitle, ogDescription]);

  return null;
};

export default SeoMeta;
